import React from "react";
import Orders from './orders'

const OrdersPage = () => {
  return <Orders url='/orders/daily' />
}

export default OrdersPage;
